export default "__VITE_ASSET__f991c83e__"